import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Toggle from 'components/ReusableComponents/Toggle'
import PropTypes from 'prop-types'

import styles from './EditStepDialog.module.scss'

function ConfigurationStep({
  isEnabled,
  setIsEnabled,
  timingKind,
  timingLabel,
  daysBeforeCheckIn,
  setDaysBeforeCheckIn
}) {
  const dayOptions = Array.from({ length: 14 }, (_, i) => i + 1).reduce(
    (acc, n) => ({ ...acc, [n]: String(n) }),
    {}
  )

  return (
    <div className={styles.configurationStep}>
      <label className={styles.enabledToggle}>
        <Toggle
          checked={isEnabled}
          handleChange={e => setIsEnabled(e.target.checked)}
          isGray={false}
        />
        <span className={styles.enabledLabel}>Enabled</span>
      </label>

      <p className={styles.description}>
        Each OTA Buster step can be enabled or disabled on its own. Disabling this step does
        not turn off the other steps in the guest journey. Delivery is email-only — OTA
        bookings often do not include a phone number.
      </p>

      {timingKind === 'daysBeforeCheckIn' ? (
        <div className={styles.sendAfterSection}>
          <span className={styles.sectionLabel}>Send before check-in</span>
          <div className={styles.sendAfterInputs}>
            <Dropdown
              className={styles.valueDropdown}
              options={dayOptions}
              value={String(daysBeforeCheckIn)}
              onChange={e => setDaysBeforeCheckIn(Number(e.target.value))}
              isSortedAlphabetically={false}
            />
            <span className={styles.unitLabel}>
              {daysBeforeCheckIn === 1 ? 'day' : 'days'}
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.fixedTiming}>
          <span className={styles.sectionLabel}>Send timing</span>
          <p className={styles.fixedTimingValue}>{timingLabel}</p>
        </div>
      )}

      <div className={styles.channelSection}>
        <span className={styles.sectionLabel}>Message channel</span>
        <p className={styles.channelDescription}>
          Email only — text is not used for OTA Buster guest campaigns.
        </p>
      </div>
    </div>
  )
}

ConfigurationStep.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  setIsEnabled: PropTypes.func.isRequired,
  timingKind: PropTypes.oneOf(['event', 'daysBeforeCheckIn']).isRequired,
  timingLabel: PropTypes.string.isRequired,
  daysBeforeCheckIn: PropTypes.number,
  setDaysBeforeCheckIn: PropTypes.func
}

export default ConfigurationStep
